"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBiMiddleware = function (_a) {
    var bi = _a.bi, eventMap = _a.eventMap, extendEvent = _a.extendEvent;
    var PROD = window.location.hostname.includes('wix');
    var log = function (action, store) {
        var transformEvent = eventMap[action.type];
        if (PROD && !!transformEvent) {
            var biEvent = extendEvent(transformEvent(store.getState(), action));
            bi.log(biEvent);
        }
    };
    return function (store) { return function (next) { return function (action) {
        log(action, store);
        return next(action);
    }; }; };
};
exports.createBiMiddlewareWithBiParams = function (_a) {
    var bi = _a.bi, eventMap = _a.eventMap, biParams = _a.biParams;
    var PROD = biParams.appParams.baseUrls.staticsBaseUrl.includes('wix');
    var log = function (action, store) {
        var transformEvent = eventMap[action.type];
        if (PROD && transformEvent) {
            var biEvent = transformEvent(store.getState(), action, biParams);
            bi.log(biEvent, { endpoint: eventMap.endpoint });
        }
        else if (transformEvent) {
            console.log(transformEvent(store.getState(), action, biParams));
        }
    };
    return function (store) { return function (next) { return function (action) {
        if (action) {
            log(action, store);
        }
        return next(action);
    }; }; };
};
